import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { AccessPermission } from "@entrilia/shared/api/types";
import type { UserInfo } from "../api/userTypes";

interface Props {
  userInfo: UserInfo;
  permissions: AccessPermission[];
}

const UserContext = createContext<Props | undefined>(undefined);

export const UserContextProvider = ({ children, ...props }: PropsWithChildren<Props>) => (
  <UserContext value={props}>{children}</UserContext>
);

export default UserContext;
